import { sessionQueryOptions } from "@/lib/query-options";
import { Outlet, createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/admin/_guard",
)({
  component: RouteComponent,
  beforeLoad: async ({ context }) => {
    const queryClient = context.queryClient;
    try {
      const session = await queryClient.ensureQueryData(sessionQueryOptions);
      if (session?.user?.role !== "admin") {
        throw redirect({
          to: "/",
          replace: true,
        });
      }
    } catch (error) {
      console.error("Failed to fetch session or check admin role:", error);
      throw redirect({
        to: "/login",
        replace: true,
      });
    }
  },
});

function RouteComponent() {
  return <Outlet />;
}
